// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { faUsdCircle } from '@fortawesome/pro-regular-svg-icons/faUsdCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import { isUserAtLeastPartiallyRegistered } from '../../redux/modules/user';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import noop from '../../utils/noop';
import ShouldLogInContainer from '../../components/ShouldLogIn/ShouldLogInContainer';
import styles from './ItemPriceGatewayContainer.module.scss';
import { toggleItemSave } from '../../redux/modules/saveItem';

const mapStateToProps = state => {
    return {
        userAtLeastPartiallyRegistered: isUserAtLeastPartiallyRegistered(state),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            toggleItemSave,
        },
        dispatch
    );

type Props = {
    children: React.Node,
    containerClassName?: string,
    iconClassName?: string,
    userAtLeastPartiallyRegistered?: boolean,
};

class ItemPriceGatewayContainer extends React.Component<Props> {
    shouldComponentUpdate = nextProps => !isEqual(this.props, nextProps);

    render() {
        const { children, containerClassName, iconClassName, userAtLeastPartiallyRegistered } = this.props;

        const containerClasses = classNames(styles.container, containerClassName);
        const iconClasses = classNames(styles.icon, iconClassName);

        const forceSignUp = !userAtLeastPartiallyRegistered;

        const content = userAtLeastPartiallyRegistered ? (
            children
        ) : (
            <span className={containerClasses}>
                <Link>
                    <FontAwesomeIcon className={iconClasses} icon={faUsdCircle} />
                    <FormattedMessage id="price_gateway_card" />
                </Link>
            </span>
        );

        return (
            <ShouldLogInContainer
                forceSignUp={forceSignUp}
                requireLogin={false}
                requireUserAtLeastPartiallyRegistered
                runFunction={noop}
            >
                {content}
            </ShouldLogInContainer>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemPriceGatewayContainer);
